import { Box, Typography } from "@mui/material";
import React from "react";
import TransferList from "./TransferList";
import { useSelector } from "react-redux";

export default function SkuPgSearchResult() {
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const { productGroups, selectedPGs, is_sku_refresh } = setupState;
	return (
		<Box
			sx={{
				mt: 4,
				p:2,
				border: 1,
				borderColor: "#c6c6c6"

			}}
		>
			<Box sx={{}}>
				<Typography variant="subtitle1"></Typography>
			</Box>

			<Box container sx={{ mt: 2, justifyContent: "space-between"}}>
				<TransferList sx={{justifyContent: "space-between",}}
					leftList={productGroups}
					rightList={selectedPGs}
					leftState={"productGroups"}
					rightState={"selectedPGs"}
					isCustomer = {false}
					refresh = {is_sku_refresh}
				/>
			</Box>
		</Box>
	);
}
